import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { FAQS } from '@/content/site';
import { TID } from '@/constants/testIds';

const ease = [0.16, 1, 0.3, 1];

export default function FAQ() {
  return (
    <section id="faq" className="py-28 lg:py-36 bg-[hsl(var(--cream-2))]/70 border-y border-[hsl(var(--hairline))]/70">
      <div className="max-w-3xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.9, ease }}
        >
          <div className="text-overline mb-7">FAQ</div>
          <h2 className="font-display text-[1.75rem] sm:text-3xl lg:text-[2.5rem] leading-[1.15]">
            Lash lift in Vancouver —
            <span className="italic text-[hsl(var(--primary))] font-medium"> frequently asked.</span>
          </h2>
          <p className="mt-7 text-[hsl(var(--muted-foreground))] leading-relaxed">
            Everything you need to know before your appointment. Still curious? Call us at{' '}
            <a href="tel:+16047646452" className="underline underline-offset-[6px] decoration-[hsl(var(--hairline))] hover:text-[hsl(var(--primary))] hover:decoration-[hsl(var(--primary))] transition-colors">
              604-764-6452
            </a>
            .
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-80px' }}
          transition={{ duration: 0.95, ease, delay: 0.1 }}
        >
          <Accordion type="single" collapsible className="mt-14">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={TID.faqItem(i)}
                className="border-b border-[hsl(var(--hairline))] last:border-b-0"
              >
                <AccordionTrigger className="py-7 text-left font-display text-[1.1rem] lg:text-[1.35rem] tracking-tight hover:no-underline hover:text-[hsl(var(--primary))] transition-colors duration-500 [&[data-state=open]]:text-[hsl(var(--primary))]">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="pb-7 text-[hsl(var(--muted-foreground))] leading-[1.8] text-[0.96rem]">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
